<template>
    <header class="header">

<!--      Desktop header-->
      <div class="header-desktop">
        <div :class="{'header-back': true, 'first-visit': !hasHistory() || this.prevRoute === 'public-login'}" @click="goBack()">
        </div>
        <header-search class="desktop"></header-search>
        <div class="header-menu">
          <div class="header-menu-folders">
            <router-link @click.native="selectFolder(item)" :to="{name:'home'}" class="header-menu-folders-item" v-for="(item, index) in $store.state.folders" :key="index" >
              <span>{{item.path | formatRootFolderName}}</span>
            </router-link>
            <a v-if="$store.state.folders.length === 0" class="header-menu-folders-item">
              No folders
            </a>
          </div>
          <div class="header-menu-items">
            <div class="header-menu-items-item dropdown" ref="dropdownToggle1">
              <a
                :class="{'dropdown-toggle': true, 'open': dropdownOpen, 'active': ['history', 'users', 'settings', 'orders', 'addresses'].indexOf($route.name) > -1}"
                @click="toggleDropdown">
                <span>{{ ['history', 'users', 'settings', 'orders', 'addresses'].indexOf($route.name) > -1 ? ($route.meta && $route.meta.label ? $route.meta.label : $route.name)  : 'Account' }}</span>
              </a>
              <div :class="{'dropdown-options': true, 'open': dropdownOpen}">
                <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager', 'designer'])" :to="{name:'history'}" class="dropdown-options-option">
                  My History
                </router-link>
                <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/orders" class="dropdown-options-option">
                  All Orders
                </router-link>
                <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/users" class="dropdown-options-option">
                  Users
                </router-link>
                <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin'])" to="/addresses" class="dropdown-options-option">
                  Addresses
                </router-link>
                <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/settings" class="dropdown-options-option">
                  Settings
                </router-link>
                <a v-if="this.$hasRole(['admin'])" @click.prevent="cache" class="dropdown-options-option">
                  <span>Clear Cache</span>
                </a>
                <a @click="handleLogout" v-loading.fullscreen.lock="loading" class="dropdown-options-option">
                  <span>Logout</span>
                </a>
              </div>
            </div>
            <router-link :to="{name:'savedItems'}" class="header-menu-items-item">
              <span>Saved items <template v-if="$store.state.favorites.length">({{$store.state.favorites.length}})</template></span>
            </router-link>
            <router-link  :to="{name:'selects'}" class="header-menu-items-item">
              <span>Selects <template v-if="$store.state.request.length">({{$store.state.request.length}})</template></span>
            </router-link>
          </div>
        </div>
      </div>

<!--      Mobile header-->
      <div class="header-mobile">
        <div class="header-mobile-top">
          <!-- hamburger -->
          <div class="header-hamburger js-toggle-navigation" @click.stop="navOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12"><path id="ic_menu_24px" d="M3,18H21V16H3Zm0-5H21V11H3ZM3,6V8H21V6Z" transform="translate(-3 -6)"/></svg>
          </div>
          <!-- /hamburger -->
          <div class="header-menu-items">
            <div class="header-menu-items-item dropdown"
                 ref="dropdownToggle2">
              <a :class="{'dropdown-toggle': true, 'open': dropdownOpen, 'active': ['history', 'users', 'settings', 'orders', 'addresses'].indexOf($route.name) > -1}"
                 @click="toggleDropdown">
                <span>{{ ['history', 'users', 'settings', 'orders', 'addresses'].indexOf($route.name) > -1 ?  ($route.meta && $route.meta.label ? $route.meta.label : $route.name) : 'Account' }}</span>
              </a>
            </div>
            <router-link :to="{name:'savedItems'}" class="header-menu-items-item">
              <span>Saved items <template v-if="$store.state.favorites.length">({{$store.state.favorites.length}})</template></span>
            </router-link>
            <router-link  :to="{name:'selects'}" class="header-menu-items-item">
              <span>Selects <template v-if="$store.state.request.length">({{$store.state.request.length}})</template></span>
            </router-link>
          </div>
        </div>
        <div class="header-mobile-bottom">
          <div :class="{'dropdown-options': true, 'open': dropdownOpen}"
               v-closable="{
                    exclude: ['dropdownToggle1', 'dropdownToggle2'],
                    handler: 'closeDropdown'
                  }">
            <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager', 'designer'])" :to="{name:'history'}" class="dropdown-options-option">
              My History
            </router-link>
            <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/orders" class="dropdown-options-option">
              All Orders
            </router-link>
            <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/users" class="dropdown-options-option">
              Users
            </router-link>
            <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin'])" to="/addresses" class="dropdown-options-option">
              Addresses
            </router-link>
            <router-link @click.native="toggleDropdown" v-if="this.$hasRole(['admin', 'manager'])" to="/settings" class="dropdown-options-option">
              Settings
            </router-link>
            <a v-if="this.$hasRole(['admin'])" @click.prevent="cache" class="dropdown-options-option">
              Clear Cache
            </a>
            <a @click="handleLogout" v-loading.fullscreen.lock="loading" class="dropdown-options-option">
              Logout
            </a>
          </div>
          <header-search class="mobile" v-if="['home'].indexOf($route.name) > -1"></header-search>
        </div>
      </div>
    </header>
</template>

<script>
import { EventBus } from '@/services/eventbus'
import { mapState } from 'vuex'
import { HTTP } from '@/services/api'
import HeaderSearch from '@/views/Private/Components/Header/HeaderSearch'

export default {
  name: 'Header',
  props: ['prevRoute'],
  components: {
    HeaderSearch
  },

  data () {
    return {
      dropdownOpen: false,
      loading: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    goBack () {
      if (this.hasHistory) {
        this.$router.go(-1)
      }
    },
    hasHistory () {
      return window.history && window.history.length > 2
    },
    cache () {
      this.$notify({
        // title: 'Success',
        message: 'Cache reload initiated',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
      HTTP({
        method: 'POST',
        url: 'api/v1/assets/filters-refresh',
        crossdomain: true
      }).then(() => {
        this.$notify({
          // title: 'Success',
          message: 'Cached',
          type: 'success',
          position: 'bottom-right',
          duration: 1750
        })
      }).catch(() => {
      })
      this.toggleDropdown()
    },
    handleLogout () {
      this.loading = true
      setTimeout(() => {
        this.$store.dispatch('setLogout', null).then(() => {
          this.$router.push('/login')
        })
      }, 500)
    },
    closeDropdown () {
      this.dropdownOpen = false
    },
    toggleDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    },
    navOpen () {
      EventBus.$emit('navigation-open', true)
      EventBus.$emit('select-mode', false)
    }
  }
}
</script>
